import React from "react";
import { Card, CardHeader, CardBody } from "reactstrap";

const BIQuestions = ({ data }) => {
    if (!data) return null;

    const { title, liData, styles } = data;

    return (
        <Card
            style={{
                border: `1px solid ${styles?.borderColor || "#ccc"}`,
                backgroundColor: styles?.background || "#f8f9fa"
            }}
            className="mb-3"
        >
            <CardHeader
                style={{
                    backgroundColor: styles?.headerBg || "#e9ecef",
                    borderBottom: `1px solid ${styles?.borderColor || "#ccc"}`,
                    fontWeight: "700",
                    letterSpacing: "0.5px"
                }}
            >
                {title}
            </CardHeader>

            <CardBody>
                <ul className="ps-3 ps-md-4 mb-0">
                    {liData?.map((item, index) => (
                        <li key={index} className="mb-2">
                            {item?.text}
                        </li>
                    ))}
                </ul>
            </CardBody>
        </Card>
    );
};

export default BIQuestions;